import difference from 'lodash/difference';
import find from 'lodash/find';
import flatten from 'lodash/flatten';
import map from 'lodash/map';
import loadFiles from '../../loader-base/src/helpers/file-loader-helper';

let componentDependencies = {};
let resolutions = [];
let components = {};

export function lazyDownloadComponent(componentName, loadedFiles) {
    return new Promise((resolve) => {
        const dependencies = componentDependencies[componentName];
        let dependencyLinks = flatten(map(dependencies, (dependency) => {
            const resolutionObject = find(resolutions, { name: dependency });
            return resolutionObject ? resolutionObject.mainMin : [];
        }));
        dependencyLinks = difference(dependencyLinks, Array.from(loadedFiles));
        if (dependencyLinks.length === 0) {
            resolve(componentName);
        } else {
            loadFiles(dependencyLinks).then((loadedList) => {
                Object.keys(loadedList).forEach((file) => {
                    loadedFiles.add(file);
                });
                resolve(loadedList);
            });
        }
    });
}

export function initializeLazyBundleLoader(config) {
    return new Promise((resolve) => {
        ({ components } = config);
        resolve();
    });
}

export function initializeLazyLoader(newComponentDependencies, newResolutions, config) {
    return new Promise((resolve) => {
        componentDependencies = newComponentDependencies;
        resolutions = newResolutions;
        ({ components } = config);
        resolve();
    });
}

export function registerPaths(componentId) {
    if (components[componentId]) {
        const temp = {};
        temp[componentId] = components[componentId];
        window.morningstar.asterix.config.registerModulePaths(temp);
    }
}



// WEBPACK FOOTER //
// ./src/lazy-loader.js